import { tokenStore } from '@/api'
import { SyncEngine } from './syncEngine'
import { refreshSitePack, refreshStoreCache, wipeDevice } from './device'

let shared: SyncEngine | null = null

/**
 * The app-wide sync engine, wired to the real transport, the online session and revoke-wipe.
 * Lazily created on first use so hooks rendering before <SyncProvider> mounts get the same one.
 */
export function getSyncEngine(): SyncEngine {
  shared ??= new SyncEngine({
    onRevoked: () => wipeDevice(),
    hasCredentials: () => tokenStore.get() !== null,
    // Records go first and photos follow, so one photo on a weak link never holds the day's
    // purchases back (the server accepts a photo after its record; PHOTO_MISSING only after 48 h).
    mediaBeforeCommand: false,
    // Bags committed or received since the last download become loadable / placeable; runs,
    // balances and holds decided by the server show on the process and pack screens.
    onDelivered: () => Promise.all([refreshStoreCache(), refreshSitePack().catch(() => false)]),
  })
  return shared
}
